export enum Routes {
	ROOT = '/',
	DASHBOARD = '/dashboard/',
	_DASHBOARD = '/dashboard'
}
